import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CollaborateurService } from '@shared/services/cabinet/collaborateur.service';
import { AuthService } from '../services/auth.service';
import { profilOuvert } from '../fonctionnalites';
import { retourConnexionUrl } from '../page-arrivee';

/**
 * Pages de l'application connectée : session ouverte (jeton de moins de 24 h) et profil ouvert sur cette version ;
 * sinon retour à la connexion (stockage vidé si la session a expiré).
 */
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  if (!auth.isAuthenticated()) {
    // Session expirée : stockage vidé (jeton, utilisateur, droits, dossier courant) ; jamais connecté : connexion.
    return auth.sessionExpiree() ? retourConnexionUrl() : inject(Router).parseUrl('/signin');
  }
  // Session d'un profil fermé sur cette version (collaborateur quand l'accès est inactif) : retour à la connexion.
  return profilOuvert(inject(CollaborateurService).user.userType) ? true : retourConnexionUrl();
};
